/* Noreno PDP – small helpers for noreno-* sections. Only loaded by those sections.
   1. "Zum Angebot" buttons scroll to the Kaching offer in the product hero.
   2. Count-up for social-proof numbers, once, when they first become visible.
   3. UGC videos: file loads only near the viewport; muted autoplay while visible; tap to pause/resume.
   4. Before/after slider: drag to reveal.
   Does not touch cart, Kaching or checkout logic. */
(function () {
  if (window.__norenoPdpLoaded) return;
  window.__norenoPdpLoaded = true;

  var HEADER_OFFSET = 90;

  function findOffer() {
    return (
      document.querySelector('kaching-bundle') ||
      document.querySelector('.shop-product-section form[action*="/cart/add"]') ||
      document.querySelector('.shop-product-section')
    );
  }

  function scrollToOffer() {
    var target = findOffer();
    if (!target) return false;
    var top = target.getBoundingClientRect().top + window.pageYOffset - HEADER_OFFSET;
    window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
    return true;
  }

  // Capture phase: runs before the sticky bar's own inline handler, so its
  // "scroll to section" fallback only fires if the offer cannot be found.
  document.addEventListener(
    'click',
    function (event) {
      var trigger = event.target.closest(
        '[data-noreno-scroll-offer], #stickyAddToCartBtn[data-button-behavior="scroll_to_section"]'
      );
      if (!trigger) return;
      if (scrollToOffer()) {
        event.preventDefault();
        event.stopPropagation();
      }
    },
    true
  );

  // ---------- Count-up ----------
  var NUMBER = /^(\D*?)(\d+(?:[.,]\d+)?)(.*)$/;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function animate(el) {
    var match = NUMBER.exec(el.getAttribute('data-nr-final'));
    if (!match) return;
    var prefix = match[1];
    var raw = match[2];
    var suffix = match[3];
    var decimals = (raw.split(/[.,]/)[1] || '').length;
    var separator = raw.indexOf(',') > -1 ? ',' : '.';
    var target = parseFloat(raw.replace(',', '.'));
    var duration = 1600;
    var start = null;

    function frame(now) {
      if (start === null) start = now;
      var progress = Math.min((now - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      var value = (target * eased).toFixed(decimals).replace('.', separator);
      el.textContent = prefix + value + suffix;
      if (progress < 1) window.requestAnimationFrame(frame);
    }
    window.requestAnimationFrame(frame);
  }

  function initCountUp() {
    var items = document.querySelectorAll('[data-nr-count]:not([data-nr-ready])');
    if (!items.length || reduceMotion || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          animate(entry.target);
        });
      },
      { threshold: 0.6 }
    );

    items.forEach(function (el) {
      var finalText = el.textContent.trim();
      var match = NUMBER.exec(finalText);
      el.setAttribute('data-nr-ready', '');
      if (!match) return;
      el.setAttribute('data-nr-final', finalText);
      el.textContent = match[1] + '0' + match[3];
      observer.observe(el);
    });
  }

  // ---------- UGC videos: always muted; autoplay while visible, tap to pause/resume ----------
  document.addEventListener('click', function (event) {
    var card = event.target.closest('.nr-ugc__card');
    if (!card) return;
    var video = card.querySelector('video');
    if (!video) return;
    video.muted = true;
    if (video.paused) {
      video.removeAttribute('data-nr-user-paused');
      loadVideo(video);
      video.play();
    } else {
      video.setAttribute('data-nr-user-paused', '');
      video.pause();
    }
  });

  ['play', 'pause', 'ended'].forEach(function (type) {
    document.addEventListener(
      type,
      function (event) {
        var card = event.target.closest && event.target.closest('.nr-ugc__card');
        if (card) card.classList.toggle('is-playing', type === 'play');
      },
      true
    );
  });

  // Videos with data-src get their file only when they come close to the viewport.
  function loadVideo(video) {
    var src = video.getAttribute('data-src');
    if (!src) return;
    video.removeAttribute('data-src');
    video.preload = 'metadata';
    video.src = src;
  }

  function initVideoAutoplay() {
    var lazy = document.querySelectorAll('video[data-src]:not([data-nr-lazy])');
    if (lazy.length) {
      if ('IntersectionObserver' in window) {
        var loader = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              loader.unobserve(entry.target);
              loadVideo(entry.target);
            });
          },
          { rootMargin: '300px 0px' }
        );
        lazy.forEach(function (video) {
          video.setAttribute('data-nr-lazy', '');
          loader.observe(video);
        });
      } else {
        lazy.forEach(loadVideo);
      }
    }

    var videos = document.querySelectorAll('[data-nr-autoplay-all] video:not([data-nr-observed])');
    if (!videos.length || !('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          video.muted = true;
          if (entry.isIntersecting && !reduceMotion && !video.hasAttribute('data-nr-user-paused')) {
            loadVideo(video);
            var playing = video.play();
            if (playing && playing.catch) playing.catch(function () {});
          } else {
            video.pause();
          }
        });
      },
      { threshold: 0.6 }
    );
    videos.forEach(function (video) {
      video.setAttribute('data-nr-observed', '');
      observer.observe(video);
    });
  }

  // ---------- Before/after slider ----------
  document.addEventListener('input', function (event) {
    if (!event.target.classList || !event.target.classList.contains('nr-compare-slider__input')) return;
    var slider = event.target.closest('[data-nr-slider]');
    if (slider) slider.style.setProperty('--pos', event.target.value + '%');
  });

  function init() {
    initCountUp();
    initVideoAutoplay();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Theme editor: re-run when a section is added or re-rendered.
  document.addEventListener('shopify:section:load', init);
})();
